import { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { GraphType, GraphDefaultProps, GraphRender } from '../common'
import { useScatterPlotGraphOption, ScatterPlotGraphOptions } from './container/options'
import { ScatterPlotGraphActions } from './container/actions'
import { useScatterPlotGraphModel } from './container/model'
import { useScatterPlotGraphRenderOption } from './container/render'
import { useScatterPlotGraphEvents } from './container/event'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { ScatterChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

import {
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BrushComponent,
} from 'echarts/components'

import { Box } from '@mui/material'

echarts.use([
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BrushComponent,
  ScatterChart,
  CanvasRenderer,
])

const ScatterPlotGraph = <T,>({
  dashBoard,
  targetList,
  dataList,
  conditions,
  onChangeCondition,
  itemData,
  onSelected,
  isResizing,
  graphRef,
  setCsv
}: GraphDefaultProps<T>) => {
  const { options, filterText } = itemData
  const { width, height, ref } = useResizeDetector()

  const graphOption = useScatterPlotGraphOption({ dashBoard, options, targetList })
  const graphData = useScatterPlotGraphModel({ dataList, conditions, filterText, graphOption })
	const renderOption = useScatterPlotGraphRenderOption({ height: (height ?? 0), graphOption, graphData })
	const events = useScatterPlotGraphEvents({ echartRef: graphRef, graphData, onSelected, onChangeCondition })

  useEffect(
		() => setCsv({ builder: () => graphData?.csvBuilder() }),
    [graphData, setCsv]
  )
	const { xValueDef, yValueDef, sizeDef, colorDef } = graphOption
  return (
    <Box ref={ref} width="100%" height="100%">
      <GraphRender
        dashBoard={dashBoard}
        keys={[xValueDef?.key, yValueDef?.key]}
        invalid={!graphData || isResizing || ((height ?? 0) <= 10)}
        optionKeys={[sizeDef?.key, colorDef?.key]}
      >
        {(width && height) ? (
          <ReactEChartsCore
            ref={graphRef}
            echarts={echarts}
            notMerge={true}
            onEvents={events}
            option={renderOption}
            opts={{ renderer: 'canvas' }}
            style={{ width, height }}
            theme="insite"
          />
        ) : <></>}
      </GraphRender>
    </Box>
  )
}

export const ScatterPlotGraphFactory: GraphType = {
  title: '分布図',
  options: ScatterPlotGraphOptions,
  actions: ScatterPlotGraphActions,
  element: <T,>(props: GraphDefaultProps<T>) => <ScatterPlotGraph<T> {...props} />
}
